import { createSelector } from 'reselect';

import { dateUTC } from 'lib/utils/date';
import { getSetupLaborTicketsForOperation } from './getSetupLaborTicketsForOperation';

/**
 * Gets the earliest setup start date from all setup labor tickets for the work order operation.
 * Returns the earliest clockIn time from setup tickets, or null if none exist.
 */
const getLaborTicketSetupStartDate = createSelector(
  [getSetupLaborTicketsForOperation],
  (setupTickets) => {
    if (!setupTickets.length) {
      return null;
    }

    // Find the earliest clockIn time
    const earliestTicket = setupTickets.reduce((earliest, ticket) => {
      if (!ticket.clockIn) {
        return earliest;
      }
      if (!earliest || ticket.clockIn < earliest.clockIn) {
        return ticket;
      }
      return earliest;
    }, null);

    return earliestTicket?.clockIn ? dateUTC(earliestTicket.clockIn) : null;
  }
);

export { getLaborTicketSetupStartDate };
